module.exports = {"id":"199158","name":"Sergio Álvarez","rating":"77","photo":"./data/images/photos/1/199158.png","club":{"name":"Sporting Gijón","logo":"./data/images/clubs/SportingGijon.png"},"positions":["MC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergioAlvarez0.json
// module id = 3913
// module chunks = 0